import { NgModule } from '@angular/core';

import { ResizeObserverEntryDirective } from './resize-observer-entry.directive';

@NgModule({
  declarations: [ResizeObserverEntryDirective],
  exports: [ResizeObserverEntryDirective],
})
export class RtUIResizeObserverModule {}

export { ResizeObserverEntryDirective };
